import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../api';

export default function AccountRecovery({ mode }: { mode: 'forgot' | 'reset' | 'verify' }) {
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const token = params.get('token') ?? '';

  useEffect(() => {
    if (mode !== 'verify' || !token) return;
    setBusy(true);
    api.verifyEmail(token)
      .then(() => setMessage('Your email is verified. You can now sign in.'))
      .catch((err) => setError(err instanceof ApiError ? err.message : 'Verification failed.'))
      .finally(() => setBusy(false));
  }, [mode, token]);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setBusy(true); setError(null);
    try {
      if (mode === 'forgot') {
        const result = await api.forgotPassword(email);
        setMessage(result.message);
      } else if (mode === 'reset') {
        await api.resetPassword(token, password);
        setMessage('Password updated. All existing sessions were signed out.');
      }
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not complete the request.');
    } finally { setBusy(false); }
  }

  const title = mode === 'forgot' ? 'Reset your password' : mode === 'reset' ? 'Choose a new password' : 'Verify your email';
  return <div className="auth-shell"><div className="auth-card">
    <Link className="auth-brand" to="/">ScaleAds AI<small>OS 3.0</small></Link>
    <h1>{title}</h1>
    {mode === 'verify' ? <p className="auth-sub">{busy ? 'Checking your link…' : 'Email verification protects your account.'}</p> :
      <form onSubmit={submit}>
        {mode === 'forgot' ? <label className="field"><span>Email</span><input className="input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus /></label> :
          <label className="field"><span>New password</span><input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={12} required autoFocus /><em className="hint">Use at least 12 characters.</em></label>}
        <button className="btn brand auth-submit" disabled={busy || (mode === 'reset' && !token)}>{busy ? 'Working…' : 'Continue'}</button>
      </form>}
    {message && <p className="auth-sub">{message}</p>}
    {error && <p className="auth-error">{error}</p>}
    <p className="auth-switch"><Link to="/login">Return to sign in</Link></p>
  </div></div>;
}
